import type { CoverDesign } from '../../../redux/api/fymAPI.types';

/**
 * The versions of a design with their numbers: version 1 is the first one made. The list comes
 * back with the newest made first (the order of the strip). The API order is by the last change,
 * which moves with every save, so the numbers come from the creation time. Pure.
 */
export function designsByAge(designs: readonly CoverDesign[]): Array<{ design: CoverDesign; number: number }> {
  return [...designs]
    .sort((a, b) => {
      const byTime = a.createdAt.localeCompare(b.createdAt);
      return byTime !== 0 ? byTime : a.uuid.localeCompare(b.uuid);
    })
    .map((design, index) => ({ design, number: index + 1 }))
    .reverse();
}
